<div class="modal-header">
  <h4 class="modal-title"></h4>
  <button type="button" class="close" (click)="bsModalRef.hide()">&times;</button>
</div>

<div class="modal-body">
  <p>{{ message | translate}}</p>
</div>

<div class="modal-footer">
  <button class="btn btn-primary" (click)="confirm()">OK</button>
</div>
